import { LockSpec, LockSpecResult } from '@sparemin/api-sdk';
import * as types from '../../../../types';
import { IApiAction, IApiResponse, NormalizationResult } from '../types';

type ActionKey = 'EMBED_CONFIGURATION_SERVICE';
export const ACTION_KEY: ActionKey = 'EMBED_CONFIGURATION_SERVICE';

export enum ServiceMethod {
  CREATE_CONFIGURATION = 'CREATE_CONFIGURATION',
  GET_CONFIGURATION = 'GET_CONFIGURATION',
  GET_LOCK_SPEC = 'GET_LOCK_SPEC',
}

export interface IEmbedConfigurationResponse {
  configuration: types.IEmbedConfiguration;
}

export type GetConfigurationArgs = [
  string, // wid
];
export type GetConfigurationResult = IEmbedConfigurationResponse;

export type CreateConfigurationArgs = {
  durationMillis: number;
  slides?: types.ISlideshowItem[];
  textOverlayInfo?: types.ITextOverlayItem[];
  audioInfo?: types.IAudioInfo[];
  videoClips?: types.IVideoClip[];
  versionInfo?: types.IVersionInfo;
  recordingId?: number;
  dimensions?: types.IDimensions;
  soundwave?: types.ISoundwave;
  watermark?: types.IWatermark[];
  captions?: types.ICaptions;
  creatorUserId?: string;
  layers?: string[];
  lockSpec?: types.LockSpecReference;
  mainMediaContainer?: types.MediaContainer;
  mediaSegmentInfo?: types.MediaSegmentInfo[];
  progress?: types.Progress;
  timer?: types.Timer[];
  edgeVideos?: types.IEdgeVideos;
};

export type CreateConfigurationResult = IEmbedConfigurationResponse;

export type GetLockSpecArgs = {
  lockSpecId: string;
};

export type GetLockSpecResult = NormalizationResult<
  'lockSpecs',
  string,
  LockSpecResult
>;

type ApiAction<M extends ServiceMethod, A> = IApiAction<ActionKey, M, A>;

export type GetConfigurationAction = ApiAction<
  ServiceMethod.GET_CONFIGURATION,
  GetConfigurationArgs
>;

export type CreateConfigurationAction = ApiAction<
  ServiceMethod.CREATE_CONFIGURATION,
  CreateConfigurationArgs
>;

export type GetLockSpecAction = ApiAction<
  ServiceMethod.GET_LOCK_SPEC,
  GetLockSpecArgs
>;

export interface IHandle {
  (
    method: ServiceMethod.GET_CONFIGURATION,
    args: GetConfigurationArgs,
    token?: string,
  ): Promise<GetConfigurationResult>;
  (
    method: ServiceMethod.CREATE_CONFIGURATION,
    args: CreateConfigurationArgs,
    token?: string,
  ): Promise<CreateConfigurationResult>;
  (
    method: ServiceMethod.GET_LOCK_SPEC,
    args: GetLockSpecArgs,
    token?: string,
  ): Promise<GetLockSpecResult>;
}

export interface EmbedConfigurationServiceDispatch {
  (action: GetConfigurationAction): Promise<
    IApiResponse<GetConfigurationResult>
  >;
  (action: CreateConfigurationAction): Promise<
    IApiResponse<CreateConfigurationResult>
  >;
  (action: GetLockSpecAction): Promise<IApiResponse<GetLockSpecResult>>;
}

export { LockSpec, LockSpecResult };
